<template>
<div>
    <BreadCrumb class="bread" :breads="['订单管理', '联合查询']"></BreadCrumb>
    <div class="wrap" element-loading-text="加载中">
        <div class="header">
            <span class="nameFt">联合查询</span>
        </div>
        <div class="submit-form">
            <el-form ref="form" :inline="true" size="small" label-width="80px">
                <div class="submit-form__search">
                    <el-form-item label="创建时间" prop="start_time">
                        <el-date-picker v-model="time" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions" clearable></el-date-picker>
                    </el-form-item>
                    <el-form-item label="付款时间" prop="pay_start_time">
                        <el-date-picker v-model="payTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions" clearable></el-date-picker>
                    </el-form-item>
                    <el-form-item label="用户手机">
                        <el-input v-model="search.phone" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="线路名称" prop="line">
                        <el-input v-model="search.line" readonly @focus="openSimpleFindDialog('line')" suffix-icon="el-icon-search"></el-input>
                    </el-form-item>
                    <el-form-item label="点位名称" prop="point">
                        <el-input v-model="search.point" readonly :disabled="!search.line" @focus="openSimpleFindDialog('point')" suffix-icon="el-icon-search"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态" prop="status">
                        <el-select v-model="search.status" multiple placeholder="请选择" clearable>
                            <el-option v-for="(item, key) in orderStatus" :key="key" :label="item" :value="key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单号">
                        <el-input v-model="search.order_no"></el-input>
                    </el-form-item>
                    <el-form-item label="负责人" v-show="$store.getters.getUserInfo.role === 'VISITOR'">
                        <el-input v-model="search.biz_name" readonly @focus="openSimpleFindDialog('auther')" suffix-icon="el-icon-search"></el-input>
                    </el-form-item>
                    <el-form-item label="跨月支付">
                        <el-select v-model="search.span">
                            <el-option value="true" label="是"></el-option>
                            <el-option value="false" label="否"></el-option>
                            <el-option value="all" label="全部"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="支付方式">
                        <el-select v-model="search.pay_channel">
                            <el-option value="wx" label="微信代扣"></el-option>
                            <el-option value="ali" label="支付宝代扣"></el-option>
                            <el-option value="baLance" label="余额"></el-option>
                            <el-option value="offlinpay" label="线下收款"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="机器编号">
                        <el-input v-model="search.hard_number"></el-input>
                    </el-form-item>
                    <el-form-item label="识别状态">
                        <el-select v-model="search.recognition_status">
                            <el-option label="正确" value="CORRECT"></el-option>
                            <el-option label="异物" value="OTHER"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="优化显示">
                        <el-select v-model="search.is_displayed">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="优化" :value="1"></el-option>
                            <el-option label="隐藏" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="submit-form__operate">
                    <el-form-item>
                        <el-button type="primary" class="operate-button" @click="searchForm">查询</el-button>
                        <el-button type="primary" class="operate-button" @click="reset">重置</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="operate-con">
            <el-button size="small" @click="exportExcel" :disabled="tableList.length === 0">导出</el-button>
            <!-- <div class="operate-flex">
          <div style="margin-right: 20px">
            总实付金额：<span style="color:red">{{ this.result.all_sale }}元</span>
          </div>
          <div>总商品数量：<span style="color:green">{{ this.result.all_count }}件</span></div>
        </div> -->
        </div>
        <div class="table-con">
            <el-table :data="tableList" stripe v-loading="loading">
                <el-table-column label="序号" type="index" align="center" :index="indexMethod"></el-table-column>
                <el-table-column label="商家名称" prop="company_name" align="center"></el-table-column>
                <el-table-column label="订单号" prop="order_no" align="center"></el-table-column>
                <el-table-column label="机器编号" prop="machine_id" align="center"></el-table-column>
                <el-table-column label="线路名称" prop="line_name" align="center"></el-table-column>
                <el-table-column label="点位名称" prop="point_name" align="center"></el-table-column>
                <el-table-column label="创建时间" prop="created_at" align="center"></el-table-column>
                <el-table-column label="购买时长(秒)" prop="seconds" align="center"></el-table-column>
                <el-table-column label="用户手机" prop="phone" align="center"></el-table-column>
                <el-table-column label="数量" prop="qty_count" align="center"></el-table-column>
                <el-table-column label="商品名称及数量" prop="order_entrys" align="center" width="250px">
                    <!-- <div slot-scope="scope">
              <template v-for="(item, index) in scope.row.order_entrys">
                <div :key="index" v-if="scope.row.order_entrys != ''">
                  <p>{{ item.name }}</p>
                  <p style="color: rgb(219, 128, 24)">{{ item.qty }}</p>
                </div>
              </template>
            </div> -->
                </el-table-column>
                <!-- <el-table-column label="商品数量" align="center">
            <div slot-scope="scope">
              <div v-if="scope.row.order_entrys != ''">
                {{ scope.row.order_entrys[0].qty }}
              </div>
            </div>
          </el-table-column> -->
                <el-table-column label="实付金额" prop="pay_amount" align="center"></el-table-column>
                <el-table-column label="付款方式" prop="pay_channel" align="center">
                    <div slot-scope="scope">
                        <div v-if="scope.row.pay_channel == '微信代扣'">
                            {{ scope.row.pay_channel }}
                        </div>
                        <div v-if="scope.row.pay_channel == '支付宝代扣'">
                            {{ scope.row.pay_channel }}
                        </div>
                        <div v-if="scope.row.pay_channel == '线下收款'">
                            {{ scope.row.pay_channel }}
                        </div>
                        <div v-if="scope.row.pay_channel == '支付宝'">
                            {{ scope.row.pay_channel }}
                        </div>
                        <div v-if="scope.row.pay_channel == '微信'">
                            {{ scope.row.pay_channel }}
                        </div>
                        <div v-else-if="scope.row.pay_channel == '余额'">
                            {{ scope.row.pay_channel }}
                        </div>
                    </div>
                </el-table-column>
                <el-table-column label="付款时间" prop="payment_time" align="center"></el-table-column>
                <el-table-column label="识别状态" prop="recognition_status" align="center"></el-table-column>
                <el-table-column label="订单状态" prop="status" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 'WAIT_CHECK'" style="color: #ff9933">处理中</span>
                        <span v-else-if="scope.row.status == 'WAIT_PAY'" style="color: #ff0000">待支付</span>
                        <span v-else>已完成</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="250px">
                    <div slot-scope="scope">
                        <el-button size="mini" @click="openView(scope.row.id, 'look')">查看</el-button>
                        <el-button size="mini" :disabled="scope.row.status_name !== 'WAIT_CHECK'" @click="openView(scope.row.id, 'update')" type="primary" v-show="
                  $store.getters.authority({ name: 'order', type: 'update' })
                ">处理</el-button>
                    </div>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-tip">
            *订单状态为处理中的订单3天后会自动变更为订单关闭，不能退款操作
        </div>
        <div class="paginationWrap" v-if="total">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" :page-sizes="[10, 100]" layout="total,sizes, prev, pager, next" :total="total"></el-pagination>
        </div>
    </div>
    <simple-find-dialog :show="dialogVisible" :dialogData="dialogData" @close="closeSimpleDialog" :width="'500px'"></simple-find-dialog>
</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
import SimpleFindDialog from "@/components/SimpleFindDialog";
import listMixin from "@/mixins/list";
import {
    orderStatus
} from "@/plugins/enum";
import {
    download
} from "@/plugins/util";
export default {
    name: "CustomerManagement",
    data() {
        return {
            total: "",
            pageNum: "",
            result: "",
            search: {
                status: "",
                phone: "",
                line: "",
                point: "",
                start_time: "",
                end_time: "",
                pay_start_time: "",
                pay_end_time: "",
                line_id: "",
                point_id: "",
                page_index: 1,
                recognition_status: "",
                order_no: "",
                hard_number: "",
                pay_channel: "",
                span: "",
                biz_id: "",
                is_displayed: "",
            },
            pickerOptions: {
                shortcuts: [{
                        text: "最近一周",
                        onClick: function (picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick: function (picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick: function (picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            dialogData: {},
            dialogVisible: false,
            time: [],
            payTime: [],
            orderStatus: orderStatus,
        };
    },
    watch: {
        search: {
            deep: true,
            handler(newVal) {
                localStorage.setItem("searchJoint", JSON.stringify(newVal));
            },
        },
        payTime: function (val) {
            if (val) {
                // console.log(val);
                this.search.pay_start_time = val[0];
                this.search.pay_end_time = val[1];
            } else {
                this.search.pay_start_time = "";
                this.search.pay_end_time = "";
            }
        },
        immediate: true,
        deep: true,
        time: function (val) {
            if (val) {
                // console.log(val);
                this.search.start_time = val[0];
                // this.search.end_time = val[1] + " 23:59:59";
                this.search.end_time = val[1];
            } else {
                this.search.start_time = "";
                this.search.end_time = "";
            }
        },
        immediate: true,
        deep: true,
    },
    mixins: [listMixin],
    created() {
        if (JSON.parse(localStorage.getItem("searchJoint"))) {
            this.search = JSON.parse(localStorage.getItem("searchJoint"));
            console.log(this.search);
            if (this.search.start_time && this.search.end_time) {
                this.time = [this.search.start_time, this.search.end_time];
            }
            if (Array.isArray(this.search.status)) {
                var _status = this.search.status.join(",");
            }
            let jsonData = {
                status: _status,
                phone: this.search.phone,
                line: this.search.line,
                point: this.search.point,
                start_time: this.search.start_time,
                end_time: this.search.end_time,
                line_id: this.search.line_id,
                point_id: this.search.point_id,
                page_index: this.search.page_index,
                // page_index: 1,
                recognition_status: this.search.recognition_status,
                pay_channel: this.search.pay_channel,
                span: this.search.span,
                order_no: this.search.order_no,
                hard_number: this.search.hard_number,
                is_displayed: this.search.is_displayed
            };
            this.getTableData(apis.joint_orders, "get", jsonData)
                .then((res) => {
                    // console.log(res);
                    this.result = res.data.result;
                })
                .catch(() => {});
            // this.getData();
        } else if (this.$route.query) {
            this.search = Object.assign(this.search, this.$route.query);
            if (this.search.start_time && this.search.end_time) {
                this.time = [this.search.start_time, this.search.end_time];
            }
            if (!Array.isArray(this.search.status) && this.search.status.length) {
                this.search.status = this.search.status.split(",");
            }
            this.$route.query.other == true ? this.getData() : this.searchForm();
        } else {
            this.getData();
        }

        // this.search = Object.assign(this.search, this.$route.query);
        // if (this.search.start_time && this.search.end_time) {
        //   this.time = [this.search.start_time, this.search.end_time];
        // }
        // if (!Array.isArray(this.search.status) && this.search.status.length) {
        //    this.search.status = this.search.status.split(',')
        //   }
        // this.$route.query.other == true ? this.getData() : this.searchForm();
        // this.searchForm();
        // this.getData();
    },
    methods: {
        openSimpleFindDialog(type) {
            switch (type) {
                case "line":
                    this.dialogData = {
                        searchItems: [{
                            key: "name",
                            label: "线路名称",
                        }, ],
                        searchTableItem: [{
                            key: "name",
                            name: "线路名称",
                        }, ],
                        proxyLink: "terminal_line",
                        proxyType: "get",
                    };
                    break;
                case "point":
                    this.dialogData = {
                        searchItems: [{
                                key: "name",
                                label: "点位",
                            },
                            {
                                key: "line_id",
                                value: this.search.line_id,
                                hidden: true,
                            },
                        ],
                        searchTableItem: [{
                            key: "name",
                            name: "点位名称",
                        }, ],
                        proxyLink: "terminal_point_by_line",
                        proxyType: "post",
                    };
                    break;
                case "auther":
                    this.dialogData = {
                        searchItems: [{
                            key: "rel_name",
                            label: "负责人",
                        }, ],
                        searchTableItem: [{
                            key: "rel_name",
                            name: "负责人",
                        }, ],
                        proxyLink: "get_company_manage",
                        proxyType: "get",
                    };
                    break;
            }
            this.nowDialogType = type;
            this.dialogVisible = true;
        },
        //关闭上侧选择
        closeSimpleDialog(data) {
            if (data) {
                switch (this.nowDialogType) {
                    case "line":
                        this.search.line = data.name;
                        this.search.line_id = data.id;
                        break;
                    case "point":
                        this.search.point = data.name;
                        this.search.point_id = data.id;
                        break;
                    case "auther":
                        this.search.biz_id = data.id;
                        this.search.biz_name = data.rel_name;
                        break;
                }
            }
            this.dialogVisible = false;
        },
        getData() {
            this.getTableData(apis.joint_orders, "get", this.search).then((res) => {
                console.log(res);
                this.total = res.data.pagination.total_count;
                this.pageNum = res.data.pagination.page_count;
                this.result = res.data.result;
            });
        },
        searchForm() {
            if (
                this.$store.getters.getUserInfo.role === "VISITOR" &&
                !this.search.biz_id
            ) {
                this.$message.warning("请选择负责人");
                return;
            }
            if (Array.isArray(this.search.status)) {
                var _status = this.search.status.join(",");
            }
            let jsonData = {
                status: _status,
                phone: this.search.phone,
                line: this.search.line,
                point: this.search.point,
                start_time: this.search.start_time,
                end_time: this.search.end_time,
                pay_start_time: this.search.pay_start_time,
                pay_end_time: this.search.pay_end_time,
                line_id: this.search.line_id,
                point_id: this.search.point_id,
                page_index: this.search.page_index,
                // page_index: 1,
                recognition_status: this.search.recognition_status,
                pay_channel: this.search.pay_channel,
                span: this.search.span,
                order_no: this.search.order_no,
                hard_number: this.search.hard_number,
            };
            if (this.search.biz_id) {
                jsonData.biz_id = this.search.biz_id;
            }
            // this.getData();
            this.getTableData(apis.joint_orders, "get", jsonData).then((res) => {
                this.result = res.data.result;
            }).catch(() => {})
            this.search.page_index = 1;
        },
        reset() {
            this.time = "";
            this.payTime = "";
            this.search = {
                status: [],
                phone: "",
                line: "",
                point: "",
                start_time: "",
                end_time: "",
                pay_start_time: "",
                pay_end_time: "",
                line_id: "",
                point_id: "",
                page_index: 1,
                recognition_status: "",
                order_no: "",
                biz_id: "",
            };
            this.getData();
        },
        openView(id, operate) {
            // console.log(id,operate);
            this.$router.push({
                name: "JointDetails",
                query: {
                    order_id: id,
                    type: operate,
                },
                params: this.search,
            });
        },
        // exportExcel() {
        //   download(this, apis.order_export, "货柜订单.xls", "get", this.search);
        // },
        exportExcel() {
            if (this.search.start_time == '') {
                this.$message.error("请先选择创建时间")
            } else {

                let _search = Object.assign(this.search, {
                    order_join: 1
                })
                // if (this.search.start_time !== '') {
                const loading = this.$loading({
                    lock: true,
                    text: "导出下载中",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                download(this, apis.order_export, "联合查询.xls", "get", _search)
                    .then(() => {
                        loading.close();
                    })
                    .catch(() => {
                        loading.close();
                        // alert('选择数据过多,下载超时，建议清理库存重新下载')
                        this.$message({
                            message: "选择数据过多或网速较慢,下载超时，建议清理库存重新下载!",
                            type: "warning",
                        });
                    });
                // } else {
                //   this.$message.warning("请选择创建时间");
                //   return;
                // }
            }
        },
    },
    components: {
        BreadCrumb,
        SimpleFindDialog,
    },
};
</script>

<style lang="scss" scoped>
.table-tip {
    color: red;
    font-size: 12px;
    margin-top: 20px;
}

.operate-con {
    display: flex;

    // justify-content: space-between;
    .operate-flex {
        display: flex;
        margin-left: 1200px;
        margin-top: 10px;
    }
}
</style>
